import React, { useCallback, useEffect, useState } from "react";
import InfoBox from "common-ui-components/components/info-box/InfoBox";
import HeatMap from "common-ui-components/components/heat-map/HeatMap";
import API from "common-ui-components/components/utils/API";

const MissingPatchAging = () => {
  const [matrix, setMatrix] = useState(null);
  const [loading, setLoading] = useState(true);

  const fetchMatrix = useCallback(async (signal) => {
    try {
      const response = await API.get(
        "/inventory/missing-patch-age-severity/heatmap",
        { signal },
      );
      if (!signal.aborted && response?.status?.success) {
        setMatrix(response.body || null);
      }
    } catch (error) {
      if (!signal.aborted) {
        console.error("Failed to load missing patch age heatmap:", error);
      }
    } finally {
      if (!signal.aborted) setLoading(false);
    }
  }, []);

  useEffect(() => {
    const controller = new AbortController();
    fetchMatrix(controller.signal);
    return () => controller.abort();
  }, [fetchMatrix]);

  return (
    <InfoBox
      header={matrix?.title || "Missing Patch Aging"}
      subtitle="Identify long-outstanding security gaps"
      badge={loading ? "Loading" : `${(matrix?.grandTotal ?? 0).toLocaleString()} missing`}
      badgeProps={{ style: { background: "#fff1d6", color: "#92400e" } }}
      style={{ minWidth: 0 }}
    >
      {!loading && !matrix ? (
        <div role="alert">Unable to load the missing patch age heatmap.</div>
      ) : (
        <HeatMap
          data={matrix}
          isLoading={loading}
          footnote="Cell color fades from the upper-left to the lower-right"
        />
      )}
    </InfoBox>
  );
};

export default MissingPatchAging;
